module.exports = __webpack_public_path__ + "img/trx_cryptocurrencies_icon_188339.04253b6.svg";